import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  TextField,
  Modal,
  DialogContent,
  MenuItem,
} from "@mui/material";
import AuthContext from "../../store/AuthContext";
import ApiEndpoints from "../../network/ApiEndPoints";
import { get, postJsonData } from "../../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
  overflowY: "scroll",
};

const EditInvoiceModal = ({ open, onClose, invoice, onSuccess }) => {
  const [updatedData, setUpdatedData] = useState({});
  const [request, setRequest] = useState(false);
  const [establishments, setEstablishments] = useState([]);
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;

  useEffect(() => {
    if (invoice) setUpdatedData(invoice);

    get(
      `${ApiEndpoints.GET_USERS_BIGG}?role=merchant`,
      "",
      setRequest,
      (res) => {
        setEstablishments(res?.data?.data || []);
      },
      (err) => {
        console.error("Failed to fetch establishments", err);
      }
    );
  }, [invoice]);

  const handleChange = (field) => (e) => {
    setUpdatedData((prev) => ({ ...prev, [field]: e.target.value }));
  };
const handleEstablishmentChange = (e) => {
  const selectedId = e.target.value;
  const selectedMerchant = establishments.find((m) => m.id === selectedId);

  const establishmentName =
    selectedMerchant?.merchant_profile?.establishment || "Unnamed Establishment";

  setUpdatedData((prev) => ({
    ...prev,
    establishment: establishmentName,      // establishment name
    user_id: selectedId,    // user id of the merchant
  }));
};


  const handleSubmit = (event) => {
    event.preventDefault();

    if (!updatedData.id) {
      apiErrorToast("Invoice ID is missing!");
      return;
    }

const formData = new FormData();
Object.keys(updatedData).forEach((key) => {
  formData.append(key, updatedData[key]);
});


    postJsonData(
      ApiEndpoints.UPDATE_INVOICE,
      formData,
      setRequest,
      () => {
        okSuccessToast("Invoice updated successfully");
        onSuccess();
      },
      (error) => apiErrorToast(error)
    );
  };

  return (
    <Box>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="sm_modal">
          <ModalHeader
            title="Update Invoice"
            subtitle="Update your invoice details."
            handleClose={onClose}
          />
          <DialogContent>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={6}>
           <TextField
  select
  label="Establishment"
  value={
    establishments.find(
      (m) => m.merchant_profile?.establishment === updatedData.establishment
    )?.id || ""
  }
  onChange={handleEstablishmentChange}
  fullWidth
>
  {establishments.map((merchant) => (
    <MenuItem key={merchant.id} value={merchant.id}>
      {merchant.merchant_profile?.establishment || "Unnamed Establishment"}
    </MenuItem>
  ))}
</TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Description"
                  value={updatedData.description || ""}
                  onChange={handleChange("description")}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Amount"
                  type="number"
                  value={updatedData.amount || ""}
                  onChange={handleChange("amount")}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Tax Rate (%)"
                  type="number"
                  value={updatedData.tax_rate || ""}
                  onChange={handleChange("tax_rate")}
                  fullWidth
                />
              </Grid>
              
            </Grid>
          </DialogContent>
          <Box sx={{ px: 3, pb: 2 }}>
            <ModalFooter
              form="edit-invoice-form"
              request={request}
              btn="Update"
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default EditInvoiceModal;
